module.exports = __webpack_public_path__ + "img/br.87032851.svg";